import { useRouter } from 'next/router';

import { generateSiteURL } from '../utils/url';

export const useCurrentUrl = () => {
  const { asPath } = useRouter();

  const currentUrl = generateSiteURL(asPath, {
    useLang: true,
  });

  return {
    currentUrl: currentUrl,
    currentUrlWithoutQueryString: currentUrl.split('?')[0],
  };
};
